const subuserStatementsEN = {
    "view": {
        "table": {
            "title": "Your Subuser's Statement list",
            "column": {
                "type": "Type",
                "year": "Year",
                "month": "Month",
                "issue_year": "Issue Year",
                "issue_month": "Issue Month",
                "description": "Description",
                "amount": "Amount",
                "status": "Status",
                "details": "Details",
                "overview": "Overview",
                "action": "Action"
            },
            "button": {
                "export_csv": "Export CSV",
                "download": "Download"
            },
            "placeholder": {
                "search": "Search..."
            },
            "label": {
                "statusOpen": "Open",
                "statusPaid": "Paid",
                "typeLicensing": "Licensing",
                "typeRegular": "Regular",
                "typeAudioMasteringServices": "Audio Mastering - Services",
                "typeVinylEarnings": "Vinyl Earnings",
                "typeOffset": "Offset",
                "typeNotKnown": "Not known",
                "monthJanuary": "January",
                "monthFebruary": "February",
                "monthMarch": "March",
                "monthApril": "April",
                "monthMay": "May",
                "monthJune": "June",
                "monthJuly": "July",
                "monthAugust": "August",
                "monthSeptember": "September",
                "monthOctober": "October",
                "monthNovember": "November",
                "monthDecember": "December"
            },
            "dropdown": {
                "markAsPaid": "Mark as PAID",
                "markAsOpen": "Mark as OPEN",
                "action": "Action"
            },
            "message": {
                "statementUnavailable": "All statements issued earlier than January 2023 are available as ZIP file attachments in your email."
            }
        },
        "message": {
            "successMarkedOpen": "Subuser statement has been marked as OPEN!",
            "successMarkedPaid": "Subuser statement has been marked as PAID!",
            "error": "Something went wrong! Please refresh page and try again!",
        },
        "modal": {
            "markAsPaid": {
                "header": "Mark statement as PAID",
                "body": "Are you sure that youwant to mark the statement {{statementName}} as PAID?"
            },
            "markAsOpen": {
                "header": "Mark statement as OPEN",
                "body": "Are you sure that you want to mark the statement {{statementName}} as OPEN?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Your Statements list",
            "column": {
                "name": "Statement name",
                "type": "Type",
                "quarter": "Quarter",
                "year": "Year",
                "month": "Month",
                "description": "Description",
                "amount": "Amount",
                "status": "Status",
                "overview": "Overview",
                "details": "Details"
            },
            "button": {
                "download": "Download",
                "export_csv": "Export CSV"

            },
            "placeholder": {
                "search": "Search..."
            },
            "label": {
                "statusOpen": "Open",
                "statusPaid": "Paid",
                "typeLicensing": "Licensing",
                "typeRegular": "Regular",
                "typeAudioMasteringServices": "Audio Mastering - Services",
                "typeVinylEarnings": "Vinyl Earnings",
                "typeOffset": "Offset",
                "typeNotKnown": "Not known",
                "quarterQ1": "Q1",
                "quarterQ2": "Q2",
                "quarterQ3": "Q3",
                "quarterQ4": "Q4",
                "monthJanuary": "January",
                "monthFebruary": "February",
                "monthMarch": "March",
                "monthApril": "April",
                "monthMay": "May",
                "monthJune": "June",
                "monthJuly": "July",
                "monthAugust": "August",
                "monthSeptember": "September",
                "monthOctober": "October",
                "monthNovember": "November",
                "monthDecember": "December"
            },
            "message": {
                "statementUnavailable": "All statements issued earlier than January 2023 were sent via email to your account manager."          
            }
        }
    }
};

export default subuserStatementsEN;
